import React from 'react'
import { Dialog, DialogContent, DialogTitle } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import BrandLogoImgForm from './BrandLogoImgForm';

const BrandLogoImgEditSection = ({ brandLogoId, open, handleClose, fromEditAction, }) => {
    return (
        <div>
            <Dialog open={open} aria-labelledby="form-dialog-title" maxWidth="md" fullWidth>
                <DialogTitle className='form-dialog-title' id="form-dialog-title">
                    <span>Client Logo Image settings</span>
                    <IconButton onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <BrandLogoImgForm brandLogoId={brandLogoId} handleClose={handleClose} />
                </DialogContent>
            </Dialog>
        </div >
    )
}

export default BrandLogoImgEditSection